<template>
  <div
    class="grid"
    :class="classes"
    :style="styles"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'BaseGrid',

  props: {
    columns: String,
    gapColumn: String,
    gapRow: String,
    dense: Boolean
  },

  computed: {
    classes () {
      return {
        [`grid--columns-${this.columns}`]: this.columns,
        'grid--dense': this.dense
      }
    },

    styles () {
      let styles = ''
      const {
        gapColumn,
        gapRow,
      } = this

      if (gapColumn) {
        styles += `column-gap:${gapColumn};`
      }

      if (gapRow) {
        styles += `row-gap:${gapRow};`
      }

      return styles
    }
  }
}
</script>

<style lang="scss" scoped>
.grid {
  $columns: map-get($layout-insights, 'grid-columns');
  $gap: map-get($layout-insights, 'gap');
  $column-min: calc(#{100 / $columns}% - #{$gap});

  display: grid;
  grid-template-columns: repeat(auto-fit, minmax($column-min, 1fr));
  gap: $gap;

  &--dense {
    align-items: start;
  }

  @for $i from 1 through $columns {
    &--columns {
      &-#{$i} {
        grid-template-columns: repeat($i, 1fr);
      }
    }

    &-span {
      &-#{$i} {
        grid-column: span $i;
      }
    }
  }
}
</style>
